export const UNTITLED = 'Untitled';

export const getPublicDocUrl = (token: string) =>
  `${window.location.origin}/public-doc/${token}`;
